// Note: serviceWorker.ts cannot import any of this - it is compiled standalone with no
// bundler (tsconfig.workers.json), so it spells the same strings out as literals. These
// declarations are the app-side mirror and have to be kept in sync by hand.
export enum ServiceWorkerMessageType {
  Subscribe = 'PUSH_SUBSCRIBE',
  Unsubscribe = 'PUSH_UNSUBSCRIBE',
  Version = 'GET_VERSION',
  Configure = 'CONFIGURE',
  SetNotificationTemplates = 'SET_NOTIFICATION_TEMPLATES',
  ClearNotificationTemplates = 'CLEAR_NOTIFICATION_TEMPLATES',
}

export enum ServiceWorkerFailureReason {
  MissingVapidKey = 'MISSING_VAPID_KEY',
  SubscribeFailed = 'SUBSCRIBE_FAILED',
  UnsubscribeFailed = 'UNSUBSCRIBE_FAILED',
}

// Note: reason is a stable code for branching, details is the raw error message. Both
// get logged - on a device the SW console is only reachable through a remote inspector,
// so without details a failure in Kibana says nothing about the cause.
//
// Both stay optional: this crosses postMessage, so the shape is what we expect the SW to
// have sent, not something the compiler can verify.
export interface ServiceWorkerFailureResponse {
  success: false;
  reason?: ServiceWorkerFailureReason;
  details?: string;
}

interface ServiceWorkerSuccessResponse {
  success: true;
  // Note: The SW sends subscription.toJSON(), which is PushSubscriptionJSON - a plain
  // object with endpoint and keys.p256dh / keys.auth, not a PushSubscription.
  //
  // Optional despite always being present on a success, because this crosses
  // postMessage: the shape is an assumption, not something the compiler can check. The
  // command validates the fields before sending them to WebPushServer.
  subscription?: PushSubscriptionJSON;
  browserId?: string;
}

// Note: A union rather than one flat interface, so narrowing on success also narrows the
// fields - reason is not reachable on a success, and subscription is not on a failure.
export type ServiceWorkerSubscribeResponse =
  | ServiceWorkerSuccessResponse
  | ServiceWorkerFailureResponse;
